import { render, staticRenderFns } from "./UpdateCateringLevy.vue?vue&type=template&id=6a661603&scoped=true"
import script from "./UpdateCateringLevy.vue?vue&type=script&lang=js"
export * from "./UpdateCateringLevy.vue?vue&type=script&lang=js"
import style0 from "./UpdateCateringLevy.vue?vue&type=style&index=0&id=6a661603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a661603",
  null
  
)

export default component.exports